<script>
  import { push } from 'svelte-spa-router';
  import { onMount } from 'svelte';


  let signUpData = { user_id: '', user_name: '', department: '', password: '', confirmPassword: '' };
  let changeData = { user_id: '', department: '', currentPassword: '', newPassword: '', confirmNewPassword: ''};

  let showSignUp = false;
  let showChangePassword = false;
  let forgotPassword = false;

  let username = '';      //로그인용 ID
  let password = '';      //로그인용 PW
  let userInfo = null;    //세선정보
  
  let loggedInUser = null;  //로그인 정보 


  onMount(async () => {
    const savedUser = localStorage.getItem('loggedInUser');
    if (savedUser) {
      try {
        const res = await fetch('/api/users/check-session', { credentials: 'include' });
        const data = await res.json();
        if (res.ok && data.loggedIn) {
          loggedInUser = JSON.parse(savedUser);
        } else {
          localStorage.removeItem('loggedInUser');
          loggedInUser = null;
        }
      } catch (err) {
        console.error('세션 확인 실패', err);
        localStorage.removeItem('loggedInUser');
        loggedInUser = null;
      }
    }
  });


  const handleSignUp = async () => {
    const { user_id, user_name, department, password, confirmPassword } = signUpData;

    const idValid = /^[a-zA-Z0-9]{4,}$/.test(user_id);
    const nameValid = user_name.length >= 2;
    const deptValid = department.length >= 2;
    const pwValid = /^[a-zA-Z0-9]{4,}$/.test(password);

    if (!idValid) {
      alert('아이디는 영문자 또는 숫자 조합으로 4자 이상이어야 합니다.');
      return;
    }
    if (!nameValid) {
      alert('이름은 최소 2자 이상 입력해주세요.');
      return;
    }
    if (!deptValid) {
      alert('부서는 최소 2자 이상 입력해주세요.');
      return;
    }
    if (!pwValid) {
      alert('비밀번호는 영문자 또는 숫자 조합으로 4자 이상이어야 합니다.');
      return;
    }
    if (password !== confirmPassword) {
      alert('비밀번호가 일치하지 않습니다.');
      return;
    }

    try {
      const response = await fetch('/api/users/signup', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(signUpData)
      });

      const result = await response.json();
      if (response.ok) {
        alert('가입되었습니다.');
        closeDialog();
      } else {
        alert(`가입 실패: ${result.message}`);
      }
    } catch (err) {
      alert('서버 연결 오류');
      console.error(err);
    }
  };

  const handleChangePassword = async () => {
    const { user_id, department, currentPassword, newPassword, confirmNewPassword } = changeData;
    const pwValid = /^[a-zA-Z0-9]{4,}$/.test(newPassword);

    if (!user_id || !department || !newPassword || !confirmNewPassword) {
      alert('필수 항목을 모두 입력해주세요.');
      return;
    }

    if (forgotPassword && user_id.toLowerCase() === 'admin') {
      alert('관리자 ID 비밀번호 분실 시에는 개발사에 문의해주세요.');
      return;
    }

    if (!pwValid) {
      alert('신규 비밀번호는 영문자 또는 숫자 조합으로 4자 이상이어야 합니다.');
      return;
    }

    if (newPassword !== confirmNewPassword) {
      alert('신규 비밀번호가 일치하지 않습니다.');
      return;
    }

    const payload = {
      user_id,
      department,
      newPassword,
      ...(forgotPassword ? { forgot: true } : { currentPassword })
    };

    try {
      const res = await fetch('/api/users/change-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      const result = await res.json();
      if (res.ok) {
        alert('비밀번호가 변경되었습니다.');
        closeDialog();
      } else {
        alert(`실패: ${result.message}`);
      }
    } catch (err) {
      alert('서버 오류');
      console.error(err);
    }
  };



  const handleLogin = async () => {
    const res = await fetch('/api/users/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ user_id: username, password })
    });

    const result = await res.json();
    if (res.ok) {
      userInfo = result.user;
      localStorage.setItem('loggedInUser', JSON.stringify(userInfo));

      if (!userInfo.approved) {
        push('/waiting');   // 승인 대기 페이지
      } else {
        push('/dashboard'); // 정상 접근
      }
      setTimeout(() => location.reload(), 200);
    } else {
      alert(result.message);
    }
  }; 

  const handleLogout = async () => {
    await fetch('/api/users/logout', { method: 'POST', credentials: 'include'});
    userInfo = null;
    localStorage.removeItem('loggedInUser');    
    push('/login'); // 부드럽게 페이지 이동
    setTimeout(() => location.reload(), 200); // 페이지 새로고침으로 상태 초기화
  };


  // 다이얼로그 토글
  const goToSignUp = () => { showSignUp = true; };
  const goToChangePassword = () => { showChangePassword = true; };
  const closeDialog = () => {
    showSignUp = false;
    showChangePassword = false;
    forgotPassword = false;

    // 입력값 초기화
    signUpData = {
      user_id: '',
      user_name: '',
      department: '',
      password: '',
      confirmPassword: ''
    };
    changeData = {
      user_id: '',
      department: '',
      currentPassword: '',
      newPassword: '',
      confirmNewPassword: ''
    };
  };
</script>

<main>
  <div class="container">

    <div class="login-box">
      <!-- <h1>S&D</h1> -->      
      <div class="logo-container">
        <img src="../images/sndlogo.png" alt="logo" class="logo-image" />
        <p class="subtitle">Smart Factory System</p>
      </div>



      {#if loggedInUser}
        <!-- 로그인된 상태 -->        
        <p class="user-info">{loggedInUser.id}({loggedInUser.department})로 로그인 되었습니다.</p>
        <!-- 홈 버튼-->
        <button class="btn" on:click={() => push('/dashboard')}>HOME</button>
        <!-- 로그아웃 버튼 -->
        <button class="btn" on:click={handleLogout}>로그아웃</button>

      {:else}
        <!-- 로그인되지 않은 상태 -->
        <input type="text" placeholder="아이디를 입력하세요" bind:value={username} />
        <input type="password" placeholder="비밀번호를 입력하세요" bind:value={password}
          on:keydown={(e) => e.key === 'Enter' && handleLogin()}
        />

        <button class="btn" on:click={handleLogin}>로그인</button>

        <div class="actions">
          <button on:click={goToSignUp}>회원가입</button>
          <button on:click={goToChangePassword}>비밀번호변경</button>
        </div>
      {/if}
    </div>
  </div>

  <!-- 다이얼로그 오버레이 -->
  {#if showSignUp || showChangePassword}
    <div class="dialog-overlay">
      <div class="dialog-box">
        <h2>{showSignUp ? '회원가입' : '비밀번호 변경'}</h2>

        {#if showSignUp}
          <p class="dialog-hint">신규 아이디를 생성합니다.<br />부서명은 아이디 구분을 위해 사용됩니다.</p>
          <input type="text" placeholder="아이디 (영문 또는 숫자, 4자 이상)" bind:value={signUpData.user_id} />
          <input type="text" placeholder="이름 (2자 이상)" bind:value={signUpData.user_name} />
          <input type="text" placeholder="부서명 (2자 이상)" bind:value={signUpData.department} />
          <input type="password" placeholder="비밀번호 (영문 또는 숫자, 4자 이상)" bind:value={signUpData.password} />
          <input type="password" placeholder="비밀번호 확인" bind:value={signUpData.confirmPassword} 
            on:keydown={(e) => e.key === 'Enter' && handleSignUp()}
          />
          <button class="btn" on:click={handleSignUp}>신규 가입</button>
        {:else}
          <p class="dialog-hint">비밀번호를 분실했을 경우,부서명과 아이디가 일치하면<br /> 기존 비밀번호 없이 신규 비밀번호로 대체됩니다.</p>

          {#if forgotPassword}
            <p class="warning-message">※ 관리자 ID 비밀번호 분실시 개발사에 문의 필요</p>
          {/if}


          <label class="checkbox-container">
            <input type="checkbox" bind:checked={forgotPassword} />
            <span class="checkmark"></span> 비밀번호 분실
          </label>
          <input type="text" placeholder="아이디" bind:value={changeData.user_id} />
          <input type="text" placeholder="부서명" bind:value={changeData.department} />
          {#if !forgotPassword}
            <input type="password" placeholder="기존 비밀번호" bind:value={changeData.currentPassword} />
          {/if}
          <input type="password" placeholder="신규 비밀번호" bind:value={changeData.newPassword} />
          <input type="password" placeholder="신규 비밀번호 확인" bind:value={changeData.confirmNewPassword} 
            on:keydown={(e) => e.key === 'Enter' && handleChangePassword()}
          />
          <button class="btn" on:click={handleChangePassword}>비밀번호 변경</button>
        {/if}

        <!-- svelte-ignore missing-declaration -->
        <button on:click={closeDialog} class="close-btn">닫기</button>
      </div>
    </div>
  {/if}

</main>



<style>


  main {
    background: linear-gradient(to bottom right, #cfcfca, #f5f5ea);
    color: #cfcfca;
    box-sizing: border-box;
    position: fixed;
    top: 0; left: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;
    overflow: hidden; /* 불필요한 스크롤 제거 */
  }

  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
    font-family: 'Segoe UI', sans-serif;
    padding: 20px; /* 여기로 이동 */
    box-sizing: border-box;
  }


  .login-box {
    width: 90%;
    max-width: 480px; /* 데스크탑에서는 최대 480px */
    padding: 24px;
    border: 1px solid #cfcfca;
    border-radius: 12px;
    background-color: #fcfcf8;
    box-shadow: 0 8px 32px rgba(94, 94, 74, 0.2); /* 밤색 계열 그림자 */
    text-align: center;
  }

  .logo-container {
    text-align: center;
    margin-top: 20px;
  }

  .logo-image {
    width: 240px; /* 원하는 크기로 조절 가능 */
    height: auto;
    margin-bottom: 20px; /* 로고 아래 여백 */
  }

  .subtitle {
    font-size: 1.4rem;
    color: #333;
    margin-top: 0;
  }


  .subtitle {
    font-size: 1rem;
    margin-bottom: 24px;
    color: #7a7a6a; /* 회색빛 밤색 */
  }
  input {
    width: 100%;
    padding: 10px;
    margin: 8px 0;
    border: 1px solid #b0b0a0;
    border-radius: 6px;
    font-size: 0.95rem;
    background-color: #fff;
    color: #5e5e4a;
  }
  .btn {
    width: 100%;
    padding: 10px;
    margin-top: 12px;
    border: none;
    border-radius: 6px;
    background-color: #b6b69e;
    color: #fff;
    font-size: 1rem;
    cursor: pointer;
  }
  .btn:hover {
    background-color: #92927b;
  }
  .actions {
    display: flex;
    justify-content: space-between;
    margin-top: 12px;
  }
  .actions button {
    width: 48%;
    padding: 8px;
    font-size: 0.9rem;
    border: 1px solid #5e5e4a;
    background-color: #fff;
    border-radius: 6px;
    cursor: pointer;
    color: #5e5e4a;
  }
  .actions button:hover {
    background-color: #f0f0df;
  }

  .dialog-hint {
    font-size: 16px;
    color: #999889;
  }
  
  .dialog-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10000; /* main보다 높게 */
  }
  .dialog-box {
    width: 100%;
    max-width: 520px;
    padding: 24px;
    background: #fcfcf8;
    border-radius: 12px;
    text-align: center;
  }

  .dialog-box input:not([type="checkbox"]) {
    width: 100%;
    padding: 10px;
    margin: 8px 0;
    font-size: 1rem;
    border-radius: 6px;
    border: 1px solid #b0b0a0;
    background-color: #fff;
    color: #5e5e4a;
  }
  .dialog-box input {
    width: 100%;
    padding: 10px;
    margin: 8px 0;
    font-size: 1rem;
    border-radius: 6px;
    border: 1px solid #b0b0a0;
  }
  .close-btn {
    margin-top: 12px;
    background: #7a7a6a;
    color: #ffffff;
    border: none;
    padding: 8px 12px;
    border-radius: 6px;
    cursor: pointer;
  }
  .close-btn:hover {
    background: #5e5e4a;
  }

  /* Custom Checkbox Styling */
  .checkbox-container {
    display: block;
    position: relative;
    padding-left: 28px;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 1rem;
    user-select: none;
    text-align: left;
    color: #5e5e4a;
  }
  .checkbox-container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #eee;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
  .checkbox-container:hover input ~ .checkmark {
    background-color: #dcdcd2;
  }
  .checkbox-container input:checked ~ .checkmark {
    background-color: #5e5e4a;
    border-color: #5e5e4a;
  }
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }
  .checkbox-container input:checked ~ .checkmark:after {
    display: block;
  }
  .checkbox-container .checkmark:after {
    left: 7px;
    top: 3px;
    width: 6px;
    height: 12px;
    border: solid white;
    border-width: 0 3px 3px 0;
    transform: rotate(45deg);
  }

  @media (max-width: 480px) {
    .dialog-box {
      padding: 24px;
      margin: 0 12px;
    }

    .dialog-box input {
      font-size: 0.95rem;
    }

    .close-btn {
      font-size: 0.9rem;
      padding: 6px 10px;
    }
  }
</style>
